__turbopack_context__.v({
  "accordionSlideOverwrite": "articleTableOfContents-module-scss-module__IjDf2a__accordionSlideOverwrite",
  "active": "articleTableOfContents-module-scss-module__IjDf2a__active",
  "fadeIn": "articleTableOfContents-module-scss-module__IjDf2a__fadeIn",
  "fadeOut": "articleTableOfContents-module-scss-module__IjDf2a__fadeOut",
  "scaleIn": "articleTableOfContents-module-scss-module__IjDf2a__scaleIn",
  "scaleOut": "articleTableOfContents-module-scss-module__IjDf2a__scaleOut",
  "tableOfContents": "articleTableOfContents-module-scss-module__IjDf2a__tableOfContents",
  "tableOfContentsCard": "articleTableOfContents-module-scss-module__IjDf2a__tableOfContentsCard",
  "tableOfContentsItem": "articleTableOfContents-module-scss-module__IjDf2a__tableOfContentsItem",
  "tableOfContentsLink": "articleTableOfContents-module-scss-module__IjDf2a__tableOfContentsLink",
  "tableOfContentsList": "articleTableOfContents-module-scss-module__IjDf2a__tableOfContentsList",
  "tableOfContentsNav": "articleTableOfContents-module-scss-module__IjDf2a__tableOfContentsNav",
  "tableOfContentsTitle": "articleTableOfContents-module-scss-module__IjDf2a__tableOfContentsTitle",
  "zoomIn": "articleTableOfContents-module-scss-module__IjDf2a__zoomIn",
  "zoomOut": "articleTableOfContents-module-scss-module__IjDf2a__zoomOut",
});
